<template>
	<b-modal ref="mdlError" id="mdlError" size="md" style="height: 100%" centered title="Attenzione">
		<li v-for="riga in listaErrori" :key="riga" class="event">
			<span class="mdi mdi-circle pal"></span>
			<span class="sa-timeline-date">{{ riga }}</span>
		</li>
		<template #modal-footer>
			<b-button size="sm" variant="danger" @click="onCloseClick()">OK</b-button>
		</template>
	</b-modal>
</template>

<script>
export default {
	data() {
		return {
			listaErrori: [],
		};
	},
	methods: {
		show(errors) {
			this.listaErrori = errors.split("#");
			this.$refs.mdlError.show();
		},
		onCloseClick() {
			let me = this;
			me.$refs.mdlError.hide();
		},
	},
};
</script>

<style></style>
